import { ClassifierData } from 'types/classifiers';
import { RemunerationCalcType } from 'types/matters';
import { ProjectCreateDto, ProjectDetailsDto, ProjectFormData } from 'types/projects';
import { getOptionsFromClassifier } from 'utils/formUtil';

export const projectDtoToForm = (
    project: ProjectDetailsDto,
    classifiers: Record<string, ClassifierData>
): ProjectFormData => ({
    projectName: project.projectName,
    description: project.description,
    openedDate: project.openedDate,
    closedDate: project.closedDate ?? null,
    capLimit: project.capLimit,
    capCurrencyType:
        getOptionsFromClassifier<string, string>(classifiers['CURRENCY']).find(
            (val) => val.value === project.capCurrencyTypeCode
        ) ?? null,
    supervisedByEmployee: project.supervisedByEmployee,
    responsibleEmployee: project.responsibleEmployee,
    matters: project.matters || [],
    isUsedTimeUsedForRemuneration: project.remunerationCalcTypeCode === RemunerationCalcType.EQUALS_USED_TIME,
    isNonBillable: project.isNonBillable,
    preserveNonBillableHours: project.preserveNonBillableHours,
});

/** The create or update request of the project form; a draft's may lack its name and team. */
export const projectFormToRequest = (form: ProjectFormData): ProjectCreateDto => ({
    projectName: form.projectName,
    description: form.description!,
    openedDate: form.openedDate!,
    closedDate: form.closedDate!,
    capLimit: form.capLimit!,
    capCurrencyTypeCode: form.capCurrencyType?.value,
    supervisedByEmployeeId: form.supervisedByEmployee?.id ?? null,
    responsibleEmployeeId: form.responsibleEmployee?.id ?? null,
    matterIds: form.matters.map((matter) => matter.id),
    remunerationCalcTypeCode: form.isUsedTimeUsedForRemuneration
        ? RemunerationCalcType.EQUALS_USED_TIME
        : RemunerationCalcType.EQUALS_BILLED_TIME,
    isNonBillable: form.isNonBillable,
    preserveNonBillableHours: form.preserveNonBillableHours,
});

/** The form fields each card of the project page edits; unchecking non-billable clears preserve, so both are Billing's. */
export const PROJECT_SECTION_FIELDS = {
    overview: ['projectName', 'description', 'openedDate', 'closedDate'],
    billing: ['isNonBillable', 'preserveNonBillableHours', 'isUsedTimeUsedForRemuneration'],
    team: ['supervisedByEmployee', 'responsibleEmployee'],
    cap: ['capLimit', 'capCurrencyType'],
    cases: ['matters'],
} satisfies Record<string, (keyof ProjectFormData)[]>;

export type ProjectSectionId = keyof typeof PROJECT_SECTION_FIELDS;
